import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { FAQBlockAttsInterface } from '~/types/AppData/Blocks/FAQBlockInterface';
import InlineTextBlock from '../InlineTextBlock/InlineTextBlock';

export default component$(
  ({ items, index }: FAQBlockAttsInterface): JSX.Element => {
    if (!items) return <></>;

    const question = items[0]?.value.text || '';
    const answer = items[1]?.value.html || '';
    return (
      <div id={`faq-${index}`} class='[&_p]:mt-2'>
        {question && <h2 class='font-group-large'>{question}</h2>}
        {answer && <InlineTextBlock index={index} html={answer} />}
      </div>
    );
  }
);
